module.exports = "<div class=\"avatar\" #avatarHost></div>\r\n<cm-spinner class=\"spinner\" *ngIf=\"!loaded\"></cm-spinner>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/avatar/avatar.component.html
// module id = ../../../../../src/app/shared/avatar/avatar.component.html
// module chunks = 4